export default __webpack_public_path__ + "static/media/weather-img-one.a187b7e3.png";